export default __webpack_public_path__ + "static/media/2_0032.ff1027d0.webp";